import React from 'react';
import PropTypes from 'prop-types';
import spaces from '@firsttable/web-theme/styledSpaces';
import Container from '../../atoms/Container';
import Row from '../../atoms/Row';
import Col from '../../atoms/Col';
import Title from '../../atoms/Title';
import Text from '../../atoms/Text';
import Box from '../../atoms/Box';
import Number from '../../atoms/Number';

const WhyBox = ({
  title, icon, message, textLayout, number, ...rest
}) => {
  const messageContent = (
    <Col width={[1, 1 / 2]} order={[1, 0]}>
      <Box maxWidth="450px" mx="auto">
        {number && (
          <Number
            m={['0 0 -67px -200px', '0 0 -67px -27px']}
            num={number}
            fontSize="120px"
          />
        )}
        <Title>{title}</Title>
        <Text m={0}>{message}</Text>
      </Box>
    </Col>
  );
  const imageContent = (
    <Col pt="l" textAlign="center" width={[1, 1 / 2]} mb={['m', 0]}>
      <img className="img-fluid" src={icon} alt="" />
    </Col>
  );

  // handle swapping of content
  let rightLayout = imageContent;
  let leftLayout = messageContent;

  if (textLayout === 'right') {
    rightLayout = messageContent;
    leftLayout = imageContent;
  }

  return (
    <Container {...spaces(rest)}>
      <Row alignItems="center" textAlign={['center', 'left']}>
        {leftLayout}
        {rightLayout}
      </Row>
    </Container>
  );
};

WhyBox.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.node,
  message: PropTypes.string,
  textLayout: PropTypes.oneOf(['left', 'right']),
  number: PropTypes.number,
};
WhyBox.defaultProps = {
  textLayout: 'left',
};

export default WhyBox;
